(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cc').forEach(function (root) {
    var vp = root.querySelector('.cc__viewport');
    if (!vp) return;
    if (root.classList.contains('cc--grid')) return;

    function step() {
      var card = vp.querySelector('.cc-card');
      var gap = parseFloat(getComputedStyle(vp).gap) || 16;
      return card ? card.getBoundingClientRect().width + gap : vp.clientWidth * 0.8;
    }

    root.querySelectorAll('.cc__arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.classList.contains('cc__arrow--next') ? 1 : -1;
        vp.scrollBy({ left: dir * step(), behavior: 'smooth' });
      });
    });

    if (root.dataset.autoplay === 'true') {
      var speed = (parseInt(root.dataset.speed, 10) || 4) * 1000;
      var timer;
      function start() {
        timer = setInterval(function () {
          if (vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 2) {
            vp.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            vp.scrollBy({ left: step(), behavior: 'smooth' });
          }
        }, speed);
      }
      function stop() { clearInterval(timer); }
      start();
      vp.addEventListener('mouseenter', stop);
      vp.addEventListener('mouseleave', start);
      vp.addEventListener('touchstart', stop, { passive: true });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
